import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ variant = 'dark' }) => {
  if (variant === 'landing') {
    return (
      <footer className="w-full py-16 px-6 bg-dark-bg border-t border-thin-divider">
        <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-8">
            <span className="text-xs font-medium text-muted-gray">© 2025 Projekto</span>
            <Link to="/privacy" className="text-xs font-medium text-muted-gray hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms" className="text-xs font-medium text-muted-gray hover:text-white transition-colors">Terms</Link>
            <Link to="/faq" className="text-xs font-medium text-muted-gray hover:text-white transition-colors">FAQ</Link>
            <Link to="/track" className="text-xs font-medium text-muted-gray hover:text-white transition-colors">Track</Link>
          </div>
          <div className="flex items-center gap-3">
            <span className="material-symbols-outlined text-sm text-muted-gray">verified_user</span>
            <span className="text-xs font-medium text-muted-gray">Secure payments via Razorpay</span>
          </div>
        </div>
      </footer>
    );
  }

  if (variant === 'light') {
    return (
      <footer className="w-full flex justify-center py-10 border-t border-[#e7edf3] dark:border-slate-800">
        <div className="max-w-[960px] w-full px-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#4e7397] dark:text-slate-500 text-sm">© 2025 Projekto. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-[#4e7397] dark:text-slate-500 text-sm hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-[#4e7397] dark:text-slate-500 text-sm hover:text-primary transition-colors">Terms of Service</Link>
            <Link to="/faq" className="text-[#4e7397] dark:text-slate-500 text-sm hover:text-primary transition-colors">FAQ</Link>
            <Link to="/track" className="text-[#4e7397] dark:text-slate-500 text-sm hover:text-primary transition-colors">Track Status</Link>
          </div>
        </div>
      </footer>
    );
  }

  if (variant === 'dark-form') {
    return (
      <footer className="w-full flex justify-center py-12 border-t border-[#222222]">
        <div className="max-w-[960px] w-full px-6 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-gray-600 text-sm">© 2025 Projekto. All rights reserved.</p>
          <div className="flex gap-10">
            <Link to="/privacy" className="text-gray-600 text-sm hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms" className="text-gray-600 text-sm hover:text-white transition-colors">Terms</Link>
            <Link to="/faq" className="text-gray-600 text-sm hover:text-white transition-colors">FAQ</Link>
            <Link to="/track" className="text-gray-600 text-sm hover:text-white transition-colors">Track Status</Link>
            <a href="mailto:projecktocare@gmail.com" className="text-gray-600 text-sm hover:text-white transition-colors">Contact</a>
          </div>
        </div>
      </footer>
    );
  }

  // Success page variant
  return (
    <footer className="w-full border-t border-white/10 bg-background-dark py-16">
      <div className="max-w-7xl mx-auto px-6 flex flex-col items-center gap-8">
        <div className="flex flex-wrap items-center justify-center gap-10">
          <Link to="/privacy" className="text-white/40 text-[11px] uppercase tracking-widest font-normal hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="text-white/40 text-[11px] uppercase tracking-widest font-normal hover:text-white transition-colors">Terms of Service</Link>
          <Link to="/faq" className="text-white/40 text-[11px] uppercase tracking-widest font-normal hover:text-white transition-colors">FAQ</Link>
          <Link to="/track" className="text-white/40 text-[11px] uppercase tracking-widest font-normal hover:text-white transition-colors">Track Status</Link>
          <a href="mailto:projecktocare@gmail.com" className="text-white/40 text-[11px] uppercase tracking-widest font-normal hover:text-white transition-colors">Contact</a>
        </div>
        <p className="text-white/20 text-[11px] uppercase tracking-widest font-normal">
          © 2025 Projekto. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
